import { Component, OnInit } from '@angular/core';
import { faPlus, faPaperPlane, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { Config } from '../config';
declare var $: any;
import { ProjectServicesService } from '../shared/services/project-services.service';
@Component({
  selector: 'app-chat-gpt-assistant',
  templateUrl: './chat-gpt-assistant.component.html',
  styleUrls: ['./chat-gpt-assistant.component.scss']
})
export class ChatGptAssistantComponent implements OnInit {
  faPaperPlane = faPaperPlane;
  faTrashAlt = faTrashAlt;
  loader: any = false;
  selectedQuery: any = '';
  selectedQueryFinal: any = '';
  selectedEUTname: any = '';
  selectedEUTDescription: any = '';
  chatGPTquery: any = '';
  assistantErrorMsg: any = '';
  assistantToken: any = '';
  maxTokens: any;
  assistantModel: any;
  assistantQuestionsType: any = 'Default';
  assistantQuestions: any = '';
  assistantHistoryArray: any;
  assistantTool: any;
  assistantChatActive: any;
  assistantStorage: any;
  assistantMessages: any;
  assistantChat: any;
  lastActiveProjectAccordId: any = '';
  selectedPrompt: any;
  entityTestID: any;
  assistantData: any;
  projectID: any;
  assistantHTML: any;
  assistantResponse: any;
  loginDetails: any;
  userDetails: any;
  accumulatedText: any = '';
  prompthtml: any = '';
  dynamichtml: any = '';
  finalhtml: any = '';
  constructor(public config: Config, private ProjectServices: ProjectServicesService) { }

  ngOnInit(): void {
    this.getAssistantToken();
    this.assistantQuestions = this.config.questionsAnswers;
    this.assistantTool = window.localStorage.getItem("assistantTool");
    this.selectedEUTname = '';
    this.selectedEUTDescription = '';
    this.entityTestID = window.localStorage.getItem("entityTestID");
    this.projectID = window.localStorage.getItem("projectID");
    this.loginDetails = window.localStorage.getItem("loginDetails");
    this.loginDetails = JSON.parse(this.loginDetails);
    setInterval(() => {
      this.selectedEUTname = window.localStorage.getItem("entityTestName");
      this.selectedEUTDescription = window.localStorage.getItem("entityTestDescription");
    }, 1000);
    this.setUpPrompts();
  }

  addprompts() {
    let obj = {
      "assistantInstructions": JSON.stringify(this.config.assistantMessages),
      "assistantChat": JSON.stringify(this.config.assistantChat),
      "assistantChatRECON": JSON.stringify(this.config.assistantChatRECON),
    }
    this.ProjectServices.addAssistantPrompts(obj).subscribe(
      (response: any) => {
        // console.log("r", response);
      })
  }
  setUpPrompts() {
    if (this.assistantTool != 'RECON') {
      var data = {
        "project_ID": this.projectID,
        "entity_ID": this.entityTestID
      }
    } else {
      var data = {
        "project_ID": this.projectID,
        "entity_ID": this.projectID
      }
    }

    this.ProjectServices.getAssistantMessages(data).subscribe(
      (response: any) => {
        if (response.status == 200) {
          $('#exportSheet').empty();
          $('#exportSheet1').empty();
          $('#exportSheet2').empty();
          // console.log("response", response);
          this.assistantResponse = response.data;
          console.log("assistantResponse", this.assistantResponse);
          this.assistantChat = JSON.parse(this.assistantResponse.assistantEntityWiseChat);
          this.assistantHTML = JSON.parse(this.assistantResponse.assistantResponseHTML);
          if (this.assistantHTML == "" || this.assistantHTML == undefined) {
          } else {
            $('#exportSheet').empty();
            $('#exportSheet1').empty();
            $('#exportSheet2').empty();
            $('#exportSheet2').append(this.assistantHTML);
          }
          this.assistantMessages = JSON.parse(this.assistantResponse.assistantMessages);
        }
        if (response.status == 401) {
          this.addAssistantMessages();
        }
        // console.log("this.assistantChat", this.assistantChat);
        if (this.assistantChat) {
          if (this.assistantTool == "ET-LS") {
            this.assistantHistoryArray = this.assistantChat[0].choices;
            this.assistantQuestions = this.assistantChat[0].choices;
          } else if (this.assistantTool == "ET-DD") {
            this.assistantHistoryArray = this.assistantChat[1].choices;
            this.assistantQuestions = this.assistantChat[1].choices;
          } else if (this.assistantTool == "ET-DE") {
            this.assistantHistoryArray = this.assistantChat[2].choices;
            this.assistantQuestions = this.assistantChat[2].choices;
          }
        }
      })
  }

  addAssistantMessages() {
    this.ProjectServices.getAssistantPrompts().subscribe(
      (response: any) => {
        // console.log("res", response);
        var defaultPrompts = response.record[0];
        this.assistantData = {
          "project_ID": this.projectID,
          // "entity_ID": this.entityTestID,
          "assistantMessages": defaultPrompts.assistantInstructions,
          // "assistantEntityWiseChat": JSON.stringify(this.config.assistantChat),
          "assistantResponseHTML": JSON.stringify(''),
          "assistantModel": this.assistantModel
        }
        if (this.assistantTool != 'RECON') {
          this.assistantData['entity_ID'] = this.entityTestID
          this.assistantData['assistantEntityWiseChat'] = defaultPrompts.assistantChat
        } else {
          this.assistantData['entity_ID'] = this.projectID
          this.assistantData['assistantEntityWiseChat'] = defaultPrompts.assistantChatRECON
        }
        this.ProjectServices.addAssistantMessages(this.assistantData).subscribe(
          (response: any) => {
            this.setUpPrompts();
          });
      });
  }

  checkCredits() {
    this.ProjectServices.getIntelligentAssistantcredits(this.assistantToken).subscribe(
      (response: any) => {
        console.log("Credits", response);
      })
  }

  getAssistantToken() {
    this.ProjectServices.getIntelligentAssistanttoken().subscribe(
      (response: any) => {
        // console.log("ChatGPT", response);
        this.assistantToken = response.token;
        this.maxTokens = response.maxtokens;
        this.assistantModel = response.assistantModel;
      })
  }

  openResponses() {
    var query = this.selectedPrompt;
    this.assistantChatActive = query;
    var entityName = window.localStorage.getItem("entityTestName");
    var entityDesc = window.localStorage.getItem("entityTestDescription");
    var prompt = ''
    if (query.type == 'PU') {
      prompt = 'analyze its potential users';
    } else if (query.type == 'FA') {
      prompt = 'analyze its non-functional attributes';
    }
    else if (query.type == 'AC') {
      prompt = 'analyze its acceptance citeria';
    }
    else if (query.type == 'BC') {
      prompt = 'analyze its behavioural conditions';
    }
    else if (query.type == 'PI') {
      prompt = 'analyze its potential issues';
    }
    else if (query.type == 'IO') {
      prompt = 'analyze its inputs & outputs';
    }
    else if (query.type == 'FS') {
      prompt = 'list down its functional scenarios';
    }
    else if (query.type == 'NFS') {
      prompt = 'list down its non-functional scenarios';
    }
    var newPrompt = {
      "role": "user",
      "content": entityName + ' is a Technical feature. Here is its description: ' + entityDesc + '. Based on the above description, ' + prompt
    }
    if (query.accessed == false) {
      this.ProjectServices.checkUserOpenAiLimits().subscribe(
        (response: any) => {
          if (response.openaiLimit > 0) {
            this.sendQuery(newPrompt, query._id);
          } else {
            $('#openAILimitExceededPopup').modal('show');
          }
        })

    } else {

    }
  }

  sendCustomPrompt(query: any) {
    this.assistantChatActive = { "query": this.chatGPTquery };
    let userPrompt =
    {
      "role": "user",
      "content": this.chatGPTquery
    };
    // console.log("query", query);
    // console.log("userPrompt", userPrompt);
    this.ProjectServices.checkUserOpenAiLimits().subscribe(
      (response: any) => {
        if (response.openaiLimit > 0) {
          this.sendQuery(userPrompt, query._id);
        } else {
          $('#openAILimitExceededPopup').modal('show');
        }
      })
  }

  triggerToastMessage(message: any) {
    this.assistantErrorMsg = message;
    setTimeout(() => {
      this.assistantErrorMsg = '';
    }, 5000);
  }

  clearChatGPTstorage() {
    $('#deleteAssistantMessagePopupModel').modal('show');

  }

  confirmDelete() {
    if (this.assistantTool != 'RECON') {
      var deleteChat = {
        "project_ID": this.assistantResponse.project_ID,
        "entity_ID": this.assistantResponse.entity_ID
      }
    } else {
      var deleteChat = {
        "project_ID": this.assistantResponse.project_ID,
        "entity_ID": this.assistantResponse.project_ID
      }
    }
    this.ProjectServices.deleteIntelligentAssistantMessages(deleteChat).subscribe(
      (response: any) => {
        $('#exportSheet').empty();
        $('#exportSheet1').empty();
        $('#exportSheet2').empty();
      })
  }

  getQuestiontype(type: any) {
    this.assistantQuestionsType = type;
    this.selectedQuery = "Type your custom query"
  }

  getAnswerfromChatGPT(selected: any) {
    console.log("selected", selected);
    this.assistantQuestionsType = 'Default';
    this.selectedQuery = selected.query;
    this.selectedPrompt = selected;
    // this.selectedQueryFinal = selected.question + ' - ' + this.selectedEUTname + ' - ' + this.selectedEUTDescription;
    ;
  }

  sendQuery(newPrompt: any, chat_id: any) {
    this.assistantMessages.push(newPrompt);
    this.triggerToastMessage("Loading responses...");
    if (this.assistantMessages) {
      this.loader = true;
      this.updateUi();
      this.ProjectServices.triggerChatGPT(this.assistantMessages, this.assistantToken, this.maxTokens, this.assistantModel).subscribe({

        // (response: any) => {
        //   console.log("response", response);
        //   // this.updateResponses(response.choices[0].message, chat_id, newPrompt);
        //   // this.updateUsageTokens(response.usage);
        //   // this.updateUserOpenAILimits();
        //   // this.selectedQuery = '';
        //   // this.chatGPTquery = '';
        //   // this.loader = false;
        // },
        // (error: any) => {
        //   // console.log("ChatGPT error", error);
        //   if (error.status == "429") {
        //     this.triggerToastMessage(error.error.error.message + " (from OpenAI)");
        //     this.loader = false;
        //   }
        //   if (error.status == "401") {
        //     this.triggerToastMessage(error.error.error.message + " (from OpenAI)");
        //     this.loader = false;
        //   }
        //   if (error.status == "404") {
        //     this.triggerToastMessage(error.error.error.message + " (from OpenAI)");
        //     this.loader = false;
        //   }
        // },

        next: (text: any) => {
          this.loader = false;
          this.selectedQuery = '';
          this.chatGPTquery = '';
          this.accumulatedText = text;
          this.updateAppendText(this.accumulatedText);
        },
        error: (err: any) => {
          console.error('Error:', err); // Handle errors if any
        },
        complete: () => {
          console.log('Streaming complete'); // Log when the streaming is complete
          // console.log("Final", this.accumulatedText);
          this.updateResponses(this.accumulatedText, chat_id, newPrompt);
        }
      }
      );
    } else {
      this.triggerToastMessage("Please choose question");
    }
  }

  updateUi() {
    // var html = '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    $('#exportSheet').empty();
    // $('#exportSheet1').empty();
    $('#exportSheet2').empty();
    // var historyQA = window.localStorage.getItem("chatgptQA-" + this.entityTestID);
    this.prompthtml = '';
    this.dynamichtml = '';
    this.accumulatedText = '';
    this.prompthtml += '<div class="row strict">';
    this.prompthtml += '<h5>' + this.assistantChatActive.query + '</h5>';
    this.prompthtml += '<span><b>(@' + (this.loginDetails.username).toLowerCase() + ' | ' + this.getCurrentDateTime24hrs() + ')</b></span>'
    this.prompthtml += '</div>';
    this.prompthtml += '<div class="row strict">';
    this.dynamichtml = '<pre style="white-space: pre-wrap !important">' + this.accumulatedText + '</pre>';
    this.dynamichtml += '</div>';
    this.dynamichtml += '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    // if (this.assistantHTML == "" || this.assistantHTML == undefined) {
    // } else {
    //   html += this.assistantHTML;
    // }
    // this.assistantHTML = html;
    $('#exportSheet').append(this.prompthtml);
    $('#exportSheet1').append(this.dynamichtml);
    if (this.assistantHTML == "" || this.assistantHTML == undefined) {
    } else {
      $('#exportSheet2').append(this.assistantHTML);
    }

    // Scroll to the top of the page
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth' // You can also use 'auto' or 'instant'
    });
    this.selectedQuery = '';
  }

  updateResponses(answer: any, chat_id: any, userPrompt: any) {
    // console.log("answer", answer);
    // console.log("chat_id", chat_id);
    // console.log("userPrompt", userPrompt);

    var response = {
      "role": "assistant",
      "content": answer
    }
    this.assistantMessages.push(response);
    // console.log("this.assistantMessages",this.assistantMessages);
    if (this.assistantTool != 'RECON') {
      for (var i = 0; i < this.assistantChat.length; i++) {
        if (this.assistantChat[i].tool == this.assistantTool) {
          for (var j = 0; j < this.assistantChat[i].choices.length; j++) {
            if (this.assistantChat[i].choices[j]._id == chat_id) {
              if (this.assistantChat[i].choices[j].accessed == true) {
                this.assistantChat[i].choices[j].messages.push(userPrompt);
              }
              this.assistantChat[i].choices[j]['accessed'] = true;
              this.assistantChat[i].choices[j].messages.push(response);
            }
          }
        }
      }
    } else {
      this.assistantChat.messages.push(userPrompt);
      this.assistantChat.messages.push(response);
    }
    // console.log("this.assistantChat",this.assistantChat);
    this.finalhtml = '';
    this.finalhtml += this.prompthtml;
    this.finalhtml += this.dynamichtml;
    if (this.assistantHTML == "" || this.assistantHTML == undefined) {
    } else {
      this.finalhtml += this.assistantHTML
    }
    console.log("this.finalhtml", this.finalhtml);
    window.localStorage.setItem('assistantChat-' + this.entityTestID, JSON.stringify(this.assistantChat));

    window.localStorage.setItem("chatgptQA-" + this.entityTestID, this.finalhtml);

    this.assistantData = {
      "project_ID": this.projectID,
      // "entity_ID": this.entityTestID,
      "assistantMessages": JSON.stringify(this.assistantMessages),
      "assistantEntityWiseChat": JSON.stringify(this.assistantChat),
      "assistantResponseHTML": JSON.stringify(this.finalhtml),
      "assistantModel": this.assistantModel
    }
    if (this.assistantTool != 'RECON') {
      this.assistantData['entity_ID'] = this.entityTestID
    } else {
      this.assistantData['entity_ID'] = this.projectID
    }
    this.ProjectServices.addAssistantMessages(this.assistantData).subscribe(
      (response: any) => {
        console.log("response", response);
        this.setUpPrompts();
      })
  }

  updateAppendText(response: any) {
    $('#exportSheet1').empty();
    this.dynamichtml = '<pre style="white-space: pre-wrap !important">' + response + '</pre>';
    this.dynamichtml += '</div>';
    this.dynamichtml += '<hr class="mt-0 mb-0" style="border-top: 1px solid black;" >';
    $('#exportSheet1').append(this.dynamichtml);
  }
  updateUsageTokens(response: any) {
    this.userDetails = window.localStorage.getItem("loginDetails");
    this.userDetails = JSON.parse(this.userDetails);
    var tokensData = {
      "username": this.userDetails.username,
      "tokensUsed": response.total_tokens,
      "_id": this.userDetails.userId,
    }
    this.ProjectServices.updateUsageTokensByUser(tokensData).subscribe(
      (response: any) => {
        console.log("response", response);
      });
  }

  updateUserOpenAILimits() {
    this.ProjectServices.updateUserOpenAILimit().subscribe(
      (response: any) => {
        console.log("response", response);
      });
  }

  getCurrentDateTime24hrs() {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');

    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    const date = `${day}-${month}-${year}`;
    const time = `${hours}:${minutes}`;

    return `${date} | ${time}`;
  }
}
